import axios from 'axios';
import store from "../../redux";
const apiTimeout = 10000;
export const submitLenderRegistration = async (data, recaptchaToken) => {
    return axios.post(`${process.env.REACT_APP_LEADS_FORM_BASE_URL}/v1/lender-registration`,data,
    {
        headers: {
            "Content-Type": "application/json",
            "reCaptchaToken": recaptchaToken,
        },
        timeout: apiTimeout
    })
}